import Emitter from "es6-event-emitter";
import language from "./../dictionary";
import template from "./../templates/downloadButtonComponent.dust";
import { createDivWithClass } from "./../../common/utilities/utils";
import APIManager from "./../../common/utilities/apimanager";
import PdfDownloadComponent from "./pdfDownloadComponent";
import { EEnabledFeatures } from "./../../common/utilities/enums";

import {
  CLICKED_FULLPDFDOWNLOAD_READER,
  CLICKED_SINGLEPAGEPDFDOWNLOAD_READER,
} from "./../../common/analytics/analyticsevents";

export default class DownloadButtonComponent extends Emitter {
  constructor(pubStore, appState, options, sessionManager) {
    super();
    this._pubStore = pubStore;
    this._appState = appState;
    this._options = options;
    this.DOMContainer = document.querySelector(
      ".top-bar-container .top-bar-access"
    );
    this._fullpdfUrl = "";
    this._pageToDownload = [];
    this._sessionManager = sessionManager;
  }

  render() {
    if (this._sessionManager.isFeatureEnabled(EEnabledFeatures.DOWNLOAD_PDF)) {
      if (this.shouldHideDownloadButton()) {
        return;
      }

      if (this.DOMContainer) {
        const context = {
          useCustomToolTip: this._options.useCustomTooltips,
          displayTopNavButtonlabel: this._options
            ? this._options.displayTopNavButtonlabel
            : false,
          i18n: language,
        };
        Dust.render(template, context, this._renderDone.bind(this));
      }
    }
  }

  _renderDone(err, result) {
    if (
      this.DOMContainer.getElementsByClassName("download-button-component")
        .length === 0
    ) {
      const div = createDivWithClass("download-button-component");
      div.setAttribute("id", "download-publication");

      if (this._options && this._options.displayTopNavButtonlabel) {
        div.classList.add("labelDisplayed");
      }
      this.DOMContainer.appendChild(div);
    }
    const donwloadButtonContainer = this.DOMContainer.getElementsByClassName(
      "download-button-component"
    )[0];
    donwloadButtonContainer.innerHTML = result;
    const downloadOptionContainer = this.DOMContainer.querySelector(
      ".download-button-component .downloadOption-container"
    );
    this._options.allowFullPdfDownload = this.fullPdfDownloadAvailable;
    this.pdfDownloadComponent = new PdfDownloadComponent(
      this._appState,
      downloadOptionContainer,
      this._options
    );
    this._attachEventListeners(); //When only full odf download is enabled.
    this._enableDownloadOptions(downloadOptionContainer);
  }

  _attachEventListeners() {
    this.iconEl = document.getElementById("download-publication");
    this._appState.on(
      "alb:overlayClicked",
      this._closeDownloadOptions.bind(this)
    );
    this._appState.on(
      "cropper:overlayClicked",
      this._closeDownloadOptions.bind(this)
    );
    this._appState.on(
      "readerContainer:clicked",
      this._closeDownloadOptions.bind(this)
    );
    this._appState.on(
      "printButton:clicked",
      this._closeDownloadOptions.bind(this)
    );
    this._appState.on(
      "categoryDropdown:opened",
      this._closeDownloadOptions.bind(this)
    );
    this._appState.on(
      "settingButton:clicked",
      this._closeDownloadOptions.bind(this)
    );
    this._appState.on(
      "readerReadingMode:clicked",
      this._closeDownloadOptions.bind(this)
    );
    this._pubStore.on("pubStore:pubLoaded", () => {
      this._closeDownloadOptions();
      this._fullpdfUrl = "";
    });

    this.iconEl.addEventListener("click", () => {
      this._appState.trigger("downloadButton:clicked");
      if (
        this.fullPdfDownloadAvailable &&
        !this.pdfDownloadButtonsConfig.single
      ) {
        //If full pdf not yet fetched, fetch it.
        this._fetchFullDownloadUrl()
          .then(() => {
            window.open(this._fullpdfUrl, "_self");
            this._sendConfirmDownload();
          })
          .catch(() => {
            //TODO some error handling?
          });
      } else {
        const pages = this._getPagesToDownload();
        //fetch full and single pdf.
        Promise.all([
          this.fullPdfDownloadAvailable
            ? this._fetchFullDownloadUrl()
            : Promise.resolve(),
          this._fetchSinglePdfUrls(pages),
        ])
          .then(() => {
            this.pdfDownloadComponent.toggleVisibility();
          })
          .catch(() => {
            //TODO some error handling?
          });
        this._appState.on(
          "appState:currentpagechanged",
          this._reset.bind(this)
        );
      }
    });
  }

  _enableDownloadOptions(downloadOptionContainer) {
    if (downloadOptionContainer) {
      if (downloadOptionContainer.classList.contains("hidden")) {
        this.pdfDownloadComponent.on(
          "pdfDownloadComponent:downloadFullPdf",
          () => {
            this._appState.triggerEvent(CLICKED_FULLPDFDOWNLOAD_READER);
            this._closeDownloadOptions();
            window.open(this._fullpdfUrl, "_blank");
            this._sendConfirmDownload();
          }
        );
        this.pdfDownloadComponent.on(
          "pdfDownloadComponent:downloadSinglePagePdf",
          () => {
            this._appState.triggerEvent(CLICKED_SINGLEPAGEPDFDOWNLOAD_READER);
            this._closeDownloadOptions();
            const url = this._pageToDownload[0].url;
            window.open(url, "_blank");
          }
        );
        this.pdfDownloadComponent.on(
          "pdfDownloadComponent:downloadLeftPagePdf",
          () => {
            this._appState.triggerEvent(CLICKED_SINGLEPAGEPDFDOWNLOAD_READER);
            this._closeDownloadOptions();
            const page = this._pageToDownload.filter((obj) => {
              return obj.position === "left";
            });
            window.open(page[0].url, "_blank");
          }
        );
        this.pdfDownloadComponent.on(
          "pdfDownloadComponent:downloadRightPagePdf",
          () => {
            this._appState.triggerEvent(CLICKED_SINGLEPAGEPDFDOWNLOAD_READER);
            this._closeDownloadOptions();
            const page = this._pageToDownload.filter((obj) => {
              return obj.position === "right";
            });
            window.open(page[0].url, "_blank");
          }
        );
      }
    }
  }

  //close the download option box and remove the event
  _closeDownloadOptions = () => {
    this.pdfDownloadComponent.close();
  };

  _reset = () => {
    this._pageToDownload = [];
    this._closeDownloadOptions();
  };

  //fetch full pdf url donwload it and send confirm download
  _fetchFullDownloadUrl() {
    if (this._fullpdfUrl == "") {
      const { FullPdfAvailable, PublicationId } =
        this._pubStore.PublicationToLoad;
      const { userId, sessionId, orderId, subscriptionId } = this._appState;

      const args = [
        userId,
        sessionId,
        orderId,
        subscriptionId,
        this._pubStore.cpID,
        FullPdfAvailable ? PublicationId : null,
      ];

      return APIManager.requestFullPDFDownload(...args)
        .then((response) => {
          if (response.Status !== "Failed") {
            return (this._fullpdfUrl = response.DownloadLink);
          }
          throw response.StatusMessage;
        })
        .catch(() => {
          throw "pdf could not be fetched";
        });
    } else {
      return Promise.resolve(this._fullpdfUrl);
    }
  }

  _sendConfirmDownload() {
    const { ContentPackageID } = this._pubStore.CPackage;
    const { userId, sessionId, downloadId } = this._appState;
    APIManager.confirmDownload({
      userId,
      sessionId,
      contentPackageId: ContentPackageID,
      downloadId,
      downloadStatus: "confirmed",
    });
  }

  //get indexes of pages to be printed
  _getPagesToDownload() {
    const pagesToBeDownloaded = [];
    const letPageIndex = this._getLeftPageIndex();
    if (typeof letPageIndex !== "undefined") {
      pagesToBeDownloaded.push({
        position: "left",
        index: letPageIndex,
        url: "",
      });
    }

    const rightPageIndex = this._getRightPageIndex();
    if (typeof rightPageIndex !== "undefined") {
      pagesToBeDownloaded.push({
        position: "right",
        index: rightPageIndex,
        url: "",
      });
    }
    return pagesToBeDownloaded;
  }

  //get the index of the left page of the currently 2 visible pages
  _getLeftPageIndex() {
    if (this._appState.activePages[0]) {
      return this._appState.activePages[0].pagePosition - 1;
    }
  }

  //get the index of the left page of the currently 2 visible pages
  _getRightPageIndex() {
    if (this._appState.activePages[1]) {
      return this._appState.activePages[1].pagePosition - 1;
    }
  }

  //get the pdf of the pages to be downloaded based on their indexes.
  _fetchSinglePdfUrls(pages) {
    if (this._pageToDownload.length == 0) {
      const { userId, sessionId, downloadId } = this._appState;
      const promises = [];

      for (const page of pages) {
        const pageIndex = page.index;
        if (this._pubStore.CPackagePages[pageIndex]) {
          const args = [
            this._pubStore.CPackagePages[pageIndex].PublicationPageID,
            sessionId,
            userId,
            downloadId,
          ];

          promises.push(
            APIManager.retrievePdfUrl(...args)
              .then((url) => {
                if (typeof url !== "undefined" && url !== "") {
                  page.url = url;
                  return this._pageToDownload.push(page);
                }
                throw "Not a valid URL";
              })
              .catch(() => {
                throw "pdf could not be fetched";
              })
          );
        }
      }
      return Promise.all(promises);
    } else {
      return Promise.resolve(this._pageToDownload);
    }
  }

  shouldHideDownloadButton() {
    const pdfDownloadDisabled = !(
      this.pdfDownloadButtonsConfig.full || this.pdfDownloadButtonsConfig.single
    );
    const onlyFullPdfDownloadEnabled =
      this.pdfDownloadButtonsConfig.full &&
      !this.pdfDownloadButtonsConfig.single;
    const fullPdfDownloadEnabledWithoutFullPdf =
      onlyFullPdfDownloadEnabled && !this.fullPdfDownloadAvailable;

    return pdfDownloadDisabled || fullPdfDownloadEnabledWithoutFullPdf;
  }

  get fullPdfDownloadAvailable() {
    const fullPdfDownloadEnabled = this.pdfDownloadButtonsConfig.full;
    const fullPdfFileAvailable =
      this._pubStore.CPackage.FullPdfAvailable ||
      this._pubStore.PublicationToLoad.FullPdfAvailable;
    return fullPdfDownloadEnabled && fullPdfFileAvailable;
  }

  get pdfDownloadButtonsConfig() {
    return this._options.reader.pdfDownloadButtonsConfig;
  }
}



// WEBPACK FOOTER //
// ./src/common/components/downloadButtonComponent.js